export const refresh_ccw = () => (
  <path
    d="M1 4v6m0 0h6m-6 0l4.64-4.36A9 9 0 0120.49 9M23 20v-6m0 0h-6m6 0l-4.64 4.36A9 9 0 013.51 15"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
